import React from 'react';
import { useIntl } from 'react-intl';

import Icon from '../../../Icon';

import styles from './styles.module.styl';

const EmptyOrganizationsState = () => {
  const { formatMessage } = useIntl();

  const title = formatMessage({
    id: 'profile.payment.onlyForOrganizationMessage',
  });

  return (
    <section className={styles.container}>
      <Icon name="card-search" width="60" height="60" className={styles.icon} />

      <div className={styles.title}>{title}</div>
    </section>
  );
};

export default EmptyOrganizationsState;



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/ProfilePaymentMethods/EmptyOrganizationsState/index.jsx